import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getProfileVerificationPopupAction,
  getProviderProfileDetailAction,
} from "../../../redux/actions/ProviderProfileDetailAction";
import moment from "moment";
import { useState } from "react";
import { ApproveRejectButton, initialFilterState } from "./helper";
import { getNetworkMenuId } from "../../../Utils/types";

export const VerificationDetailsPopup = ({
  rowData,
  searchFilter,
  apiParams,
  setRowData,
}) => {
  const dispatch = useDispatch();
  const [remark, setRemark] = useState("");
  const getViewDetailPage = useSelector(
    (state) =>
      state?.providerPortalDetailReducer?.getViewDetailPage?.profileVerification
  );

  const aadharDetails = getViewDetailPage?.uploadDocList?.filter(
    (ele) => ele.docType === "AADHAR"
  )?.[0];

  const centerRegistrationCertificateDetails =
    getViewDetailPage?.uploadDocList?.filter(
      (ele) => ele.docType === "CENTREREGISTRATIONCERTIFICATE"
    )?.[0];

  const mouDetails = getViewDetailPage?.uploadDocList?.filter(
    (ele) => ele.docType === "MOU"
  )?.[0];

  const mspDetails = getViewDetailPage?.uploadDocList?.filter(
    (ele) => ele.docType === "MSP"
  )?.[0];

  const panDetails = getViewDetailPage?.uploadDocList?.filter(
    (ele) => ele.docType === "PAN"
  )?.[0];

  useEffect(() => {
    dispatch(
      getProfileVerificationPopupAction(rowData?.requestID, rowData?.sessionID)
    );
  }, []);

  const viewDocuments = [
    {
      heading: "Aadhar Card",
      keyWord: aadharDetails,
    },
    {
      heading: "PAN Card",
      keyWord: panDetails,
    },
    {
      heading: "MSP Sheet Duly Filled",
      keyWord: mspDetails,
    },
    {
      heading: "Centre Registration Certificate",
      keyWord: centerRegistrationCertificateDetails,
    },
    {
      heading: "Signed MOU",
      keyWord: mouDetails,
    },
  ];
  return (
    <>
      <div className="___parent_container d-flex justify-content-between border-bottom modalHeader">
        <div className="d-flex align-items-center gap-10">
          <div className="logo-circle">
            <img src={rowData?.providerLogo} alt="" />
          </div>
          <div className="brand-name">
            <h5 className="mb-0 text-highlight font-bold">
              {rowData?.providerName}
            </h5>
          </div>
        </div>
        <div className="align-items-center gap-3 d-flex">
          {getViewDetailPage?.source && <h5 className="mb-0 text-highlight font-bold">
            <span style={{color:"black"}}>Action : </span>{getViewDetailPage?.source}
          </h5>}
          <button
          type="button"
          className="btn-close normal-close"
          onClick={async () => {
            await setRemark("");
            await setRowData(null);
            if (getViewDetailPage === undefined) {
              await dispatch(
                getProviderProfileDetailAction(initialFilterState)
              );
            }
          }}
        ></button>
          </div>
      </div>
      <div className="___parent_container modal-body">
        <h4
          className="font-bold text-highlight mb-4"
          style={{ letterSpacing: "1px" }}
        >
          Profile Verification
        </h4>
        <div className="d-flex justify-content-between gap-20 pv-body">
          <div className="_left-side">
            <div className="shadow-heights">
              <div className="d-flex gap-10 flex-wrap justify-content-between align-items-center bottom-spacing-10">
                <h6 className="font-medium">
                  Is your centre recognized by any association/ body ?
                </h6>
                <div
                  className={
                    getViewDetailPage?.accreditationList?.length
                      ? "pill-highlighted"
                      : "pill-un-highlighted"
                  }
                >
                  {getViewDetailPage?.accreditationList?.length ? "Yes" : "No"}
                </div>
              </div>
              <div className="d-flex flex-wrap justify-content-between align-items-center">
                <div>
                  <h6 className="font-medium">Please Specify</h6>
                </div>
                <div className="d-flex gap-3">
                  {getViewDetailPage?.accreditationList?.map((ele) => {
                    return (
                      <div className="pill-highlighted">
                        {ele?.accreditationName}
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
            <div className="spacing-hr"></div>
            <div className="modal-table-padding">
              <div className="table-responsive __custom__properties">
                <table className="table __border-none">
                  <thead>
                    <tr>
                      <th scope="col">Expiry Date</th>
                      <th scope="col">Certificates</th>
                      <th scope="col" className="custom-width-250">
                        Accreditation Documents
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {getViewDetailPage?.accreditationList?.map((ele) => {
                      return (
                        <tr>
                          <td>
                            {moment(ele?.accreditationValidity).format(
                              "DD/MM/YYYY"
                            )}
                          </td>
                          <td>{ele?.accreditationName}</td>
                          <td>
                            <a
                              href={ele?.accreditationCertificate}
                              target="blank"
                              className="text-decoration"
                            >
                              {ele?.accreditationCertificate &&
                                ele?.accreditationName.toLowerCase() +
                                  "-accreditation-certificate"}
                            </a>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="spacing-hr"></div>
          </div>
          <div className="_right-side __mt-30">
            <div className="shadow-heights d-flex flex-direction-column justify-content-between height-100">
              <div className="upload-documents">
                <h5 className="font-bold text-black bottom-spacing-30">
                  Uploaded Documents
                </h5>
                {viewDocuments?.map((ele, index) => {
                  return (
                    <div
                      key={index}
                      className="d-flex flex-wrap gap-10 align-items-center justify-content-between align-items-center bottom-spacing-10"
                    >
                      <h6 className="font-medium mb-0">{ele?.heading}</h6>
                      <div>
                        {ele?.keyWord !== undefined ? (
                          <a
                            href={ele?.keyWord?.urlPath}
                            target="blank"
                            className="text-decoration"
                          >
                            View
                          </a>
                        ) : (
                          <p className="text-unhighlighted">Not Uploaded</p>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
              <div
                className="remarks mt-4 mb-4 modal-table-padding"
                style={{ padding: "0px" }}
              >
                <h5 className="font-bold text-black bottom-spacing-20 mt-4 mb-3">
                  Remarks
                </h5>
                <textarea
                  className="textarea font-medium"
                  placeholder="Type Something Here..."
                  value={
                    rowData?.requestStatus !== "Pending for Approval"
                      ? rowData?.remarks
                      : remark
                  }
                  onChange={(e) => setRemark(e.target.value)}
                  disabled={
                    rowData?.requestStatus !== "Pending for Approval" ||
                    !getNetworkMenuId()?.canEdit
                  }
                ></textarea>
              </div>
              <div className="accept-reject-btns bottom-0">
                {rowData?.requestStatus === "Pending for Approval" &&
                  getNetworkMenuId()?.canEdit && (
                    <ApproveRejectButton
                      rowData={rowData}
                      setRowData={setRowData}
                      remark={remark}
                      setRemark={setRemark}
                      searchFilter={searchFilter}
                      apiParams={apiParams}
                    />
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
